var toString = require('./toString');

module.exports = function isArray(obj){return toString.call(obj) == '[object Array]';};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isArray.js
 ** module id = 11
 ** module chunks = 0
 **/